// Extra interface text that is merged into translations.js (see LanguageContext.js).
// Holds the topic page text for every language, plus the Topics, Grammar and Profile text for Spanish, French and Portuguese.

export const moreTranslations = {
    en: {
        topicDetail: {
            lessonsComplete: '{done} of {total} lessons complete',
            upNext: 'Up next',
            start: 'Start',
            lessonsTab: 'Lessons',
            deeperTab: 'Go deeper',
            aboutTab: 'About',
            results: 'Results',
            redo: 'Redo',
            completeFirst: 'Complete a lesson first',
            completeFirstDesc: 'Finish at least one lesson in this topic to unlock extra practice.',
            deeperIntro: 'Extra AI-generated practice for this topic, fresh content every 24 hours.',
            coreVocab: 'Core vocabulary',
            coreVocabDesc: 'Sprint through the essential words for this topic',
            grammarFocus: 'Grammar focus',
            grammarFocusDesc: 'Key grammar structures used in this topic',
            convPractice: 'Conversation practice',
            convPracticeDesc: 'Put it all together in real {lang} sentences',
            gabiConv: 'Gabi conversation',
            gabiConvDesc: 'Practice speaking with Gabi on this topic',
            min: 'min',
            whatYoullLearn: 'What you\'ll learn',
            levelLabel: 'Level',
            lessonsLabel: 'Lessons',
            lessonsInfo: '{n} lessons · approximately {m} minutes',
            includes: 'Includes',
            includesText: 'Vocabulary, grammar, pronunciation, a Gabi conversation session and a topic test.',
        },
    },
    it: {
        topicDetail: {
            lessonsComplete: '{done} di {total} lezioni completate',
            upNext: 'A seguire',
            start: 'Inizia',
            lessonsTab: 'Lezioni',
            deeperTab: 'Approfondisci',
            aboutTab: 'Info',
            results: 'Risultati',
            redo: 'Rifai',
            completeFirst: 'Completa prima una lezione',
            completeFirstDesc: 'Termina almeno una lezione di questo argomento per sbloccare la pratica extra.',
            deeperIntro: 'Pratica extra generata dall’IA per questo argomento: contenuti nuovi ogni 24 ore.',
            coreVocab: 'Vocabolario essenziale',
            coreVocabDesc: 'Ripassa a ritmo veloce le parole fondamentali di questo argomento',
            grammarFocus: 'Focus sulla grammatica',
            grammarFocusDesc: 'Le strutture grammaticali chiave usate in questo argomento',
            convPractice: 'Pratica di conversazione',
            convPracticeDesc: 'Metti insieme tutto in vere frasi in {lang}',
            gabiConv: 'Conversazione con Gabi',
            gabiConvDesc: 'Esercitati a parlare con Gabi su questo argomento',
            min: 'min',
            whatYoullLearn: 'Cosa imparerai',
            levelLabel: 'Livello',
            lessonsLabel: 'Lezioni',
            lessonsInfo: '{n} lezioni · circa {m} minuti',
            includes: 'Include',
            includesText: 'Vocabolario, grammatica, pronuncia, una sessione di conversazione con Gabi e un test sull’argomento.',
        },
    },
    es: {
        topics: {
            title: 'Temas',
            searchPlaceholder: 'Buscar temas...',
            allLevels: 'Todos los niveles',
            noTopicsFound: 'No se encontraron temas',
            tryDifferentSearch: 'Prueba con otro término de búsqueda',
            locked: 'Bloqueado',
            levelNames: {
                A1: 'Principiante',
                A2: 'Elemental',
                B1: 'Intermedio',
                B2: 'Intermedio alto',
                C1: 'Avanzado',
                C2: 'Dominio',
            },
        },
        grammar: {
            title: 'Gramática',
            searchPlaceholder: 'Busca cualquier verbo...',
            lookUp: 'Buscar',
            intro: 'Toca cualquier verbo para ver su conjugación completa en todos los tiempos y guardar formas en tu Word Bank. ¿No ves el verbo que buscas? Busca',
            introBold: 'cualquier',
            introEnd: 'verbo en el buscador de arriba, no solo los de la lista de abajo.',
            verbs: 'verbos',
        },
        profile: {
            title: 'Perfil',
            myProfile: 'Mi perfil',
            freePlan: 'Plan gratuito',
            active: 'Activo',
            tapToSwitch: 'Toca para cambiar',
            learnMultiple: 'Aprende varios idiomas y cambia entre ellos cuando quieras',
            account: 'Cuenta',
            displayName: 'Nombre visible',
            emailAddress: 'Correo electrónico',
            changePassword: 'Cambiar contraseña',
            updatePassword: 'Actualiza tu contraseña',
            prefs: 'Preferencias',
            notificationsDesc: 'Recordatorios diarios y avisos de racha',
            soundEffects: 'Efectos de sonido',
            on: 'Activados',
            helpSupport: 'Ayuda y soporte',
            helpSupportDesc: 'Preguntas frecuentes y contacto',
            termsPrivacy: 'Términos y política de privacidad',
            termsPrivacyDesc: 'Lee nuestros términos de servicio',
            dangerZone: 'Zona de peligro',
            deleteMyAccount: 'Eliminar mi cuenta',
            deleteMyAccountDesc: 'Elimina de forma permanente tu cuenta y todos tus datos',
            deleteAccountTitle: '¿Eliminar tu cuenta?',
            deleteAccountWarning: 'Se eliminarán de forma permanente tu cuenta, todo tu progreso, tu Word Bank y el historial de conversaciones. Esta acción no se puede deshacer.',
            enterPasswordConfirm: 'Escribe tu contraseña para confirmar:',
            yourPassword: 'Tu contraseña',
            deleting: 'Eliminando...',
            deleteAccountBtn: 'Eliminar cuenta',
            currentPlanFree: 'Tienes acceso a los 3 primeros temas de cada nivel y a 2 sesiones con Gabi al día.',
            unlockEverything: 'Desbloquea todo',
            unlockDesc: 'Obtén acceso completo a todos los temas, conversaciones ilimitadas con Gabi, preparación de exámenes y más.',
            featureAllTopics: 'Todos los temas de cada nivel',
            featureUnlimitedLuna: 'Conversaciones ilimitadas con Gabi',
            featureExamPrep: 'Preparación completa de exámenes',
            featureUnlimitedWordBank: 'Word Bank ilimitado',
            featureFullStats: 'Estadísticas completas y seguimiento de Cambridge',
            seePlans: 'Ver planes',
            removeLanguageTitle: '¿Quitar este idioma?',
            removeLanguageDesc: 'Se eliminarán de forma permanente todo tu progreso, tu Word Bank y tu historial de este idioma. Esta acción no se puede deshacer.',
            remove: 'Quitar',
            mustSwitchFirst: 'Debes cambiar a otro idioma antes de quitar este.',
            editProfile: 'Editar perfil',
            learning: 'Aprendiendo',
            currentLevel: 'Nivel actual',
            change: 'Cambiar',
            appLanguage: 'Idioma de la app',
            chooseAppLanguage: 'Elige el idioma de la interfaz de la app.',
            addAnotherLanguage: 'Añadir otro idioma',
            switchLanguage: 'Cambiar idioma de aprendizaje',
            switchLanguageDesc: 'Esto sustituye el idioma que estás aprendiendo ahora. Pronto podrás aprender varios idiomas a la vez.',
            stats: 'Estadísticas',
            totalXp: 'XP total',
            dayStreak: 'Días seguidos',
            wordsSaved: 'Palabras guardadas',
            lessonsDone: 'Lecciones completadas',
            settings: 'Ajustes',
            notifications: 'Notificaciones',
            support: 'Soporte y comentarios',
            logOut: 'Cerrar sesión',
            deleteAccount: 'Eliminar cuenta',
            confirmLogOut: '¿Seguro que quieres cerrar sesión?',
            cancel: 'Cancelar',
            progressTab: 'Progreso',
            languagesTab: 'Idiomas',
            settingsTab: 'Ajustes',
            subscriptionTab: 'Suscripción',
            hrsStudied: 'h de estudio',
            lessonsCompleted: 'lecciones completadas',
            levelManagement: 'Gestión del nivel',
            retakeTest: 'Repetir la prueba de nivel',
            retakeTestDesc: 'Obtén una nueva evaluación de tu nivel',
            changeLevelManually: 'Cambiar el nivel manualmente',
            currently: 'Actualmente',
        },
        topicDetail: {
            lessonsComplete: '{done} de {total} lecciones completadas',
            upNext: 'A continuación',
            start: 'Empezar',
            lessonsTab: 'Lecciones',
            deeperTab: 'Profundiza',
            aboutTab: 'Información',
            results: 'Resultados',
            redo: 'Repetir',
            completeFirst: 'Completa una lección primero',
            completeFirstDesc: 'Termina al menos una lección de este tema para desbloquear práctica extra.',
            deeperIntro: 'Práctica extra generada con IA para este tema: contenido nuevo cada 24 horas.',
            coreVocab: 'Vocabulario esencial',
            coreVocabDesc: 'Repasa a toda velocidad las palabras básicas de este tema',
            grammarFocus: 'Enfoque gramatical',
            grammarFocusDesc: 'Las estructuras gramaticales clave de este tema',
            convPractice: 'Práctica de conversación',
            convPracticeDesc: 'Júntalo todo en frases reales en {lang}',
            gabiConv: 'Conversación con Gabi',
            gabiConvDesc: 'Practica hablar con Gabi sobre este tema',
            min: 'min',
            whatYoullLearn: 'Qué aprenderás',
            levelLabel: 'Nivel',
            lessonsLabel: 'Lecciones',
            lessonsInfo: '{n} lecciones · unos {m} minutos',
            includes: 'Incluye',
            includesText: 'Vocabulario, gramática, pronunciación, una sesión de conversación con Gabi y una prueba del tema.',
        },
    },
    fr: {
        topics: {
            title: 'Sujets',
            searchPlaceholder: 'Rechercher des sujets...',
            allLevels: 'Tous les niveaux',
            noTopicsFound: 'Aucun sujet trouvé',
            tryDifferentSearch: 'Essaie un autre terme de recherche',
            locked: 'Verrouillé',
            levelNames: {
                A1: 'Débutant',
                A2: 'Élémentaire',
                B1: 'Intermédiaire',
                B2: 'Intermédiaire supérieur',
                C1: 'Avancé',
                C2: 'Maîtrise',
            },
        },
        grammar: {
            title: 'Grammaire',
            searchPlaceholder: 'Cherche n’importe quel verbe...',
            lookUp: 'Chercher',
            intro: 'Touche un verbe pour voir sa conjugaison complète à tous les temps et enregistrer des formes dans ton Word Bank. Tu ne vois pas le verbe que tu cherches ? Cherche',
            introBold: 'n’importe quel',
            introEnd: 'verbe dans la barre ci-dessus, pas seulement ceux de la liste ci-dessous.',
            verbs: 'verbes',
        },
        profile: {
            title: 'Profil',
            myProfile: 'Mon profil',
            freePlan: 'Offre gratuite',
            active: 'Actif',
            tapToSwitch: 'Touche pour changer',
            learnMultiple: 'Apprends plusieurs langues et passe de l’une à l’autre quand tu veux',
            account: 'Compte',
            displayName: 'Nom affiché',
            emailAddress: 'Adresse e-mail',
            changePassword: 'Changer de mot de passe',
            updatePassword: 'Mets à jour ton mot de passe',
            prefs: 'Préférences',
            notificationsDesc: 'Rappels quotidiens et alertes de série',
            soundEffects: 'Effets sonores',
            on: 'Activés',
            helpSupport: 'Aide et assistance',
            helpSupportDesc: 'FAQ et nous contacter',
            termsPrivacy: 'Conditions et politique de confidentialité',
            termsPrivacyDesc: 'Lis nos conditions d’utilisation',
            dangerZone: 'Zone de danger',
            deleteMyAccount: 'Supprimer mon compte',
            deleteMyAccountDesc: 'Supprime définitivement ton compte et toutes tes données',
            deleteAccountTitle: 'Supprimer ton compte ?',
            deleteAccountWarning: 'Cela supprimera définitivement ton compte, toute ta progression, ton Word Bank et l’historique de tes conversations. Cette action est irréversible.',
            enterPasswordConfirm: 'Saisis ton mot de passe pour confirmer :',
            yourPassword: 'Ton mot de passe',
            deleting: 'Suppression...',
            deleteAccountBtn: 'Supprimer le compte',
            currentPlanFree: 'Tu as accès aux 3 premiers sujets de chaque niveau et à 2 séances avec Gabi par jour.',
            unlockEverything: 'Débloque tout',
            unlockDesc: 'Obtiens un accès complet à tous les sujets, à des conversations illimitées avec Gabi, à la préparation aux examens et plus encore.',
            featureAllTopics: 'Tous les sujets à chaque niveau',
            featureUnlimitedLuna: 'Conversations illimitées avec Gabi',
            featureExamPrep: 'Préparation complète aux examens',
            featureUnlimitedWordBank: 'Word Bank illimité',
            featureFullStats: 'Statistiques complètes et suivi Cambridge',
            seePlans: 'Voir les offres',
            removeLanguageTitle: 'Retirer cette langue ?',
            removeLanguageDesc: 'Cela supprimera définitivement toute ta progression, ton Word Bank et ton historique pour cette langue. Cette action est irréversible.',
            remove: 'Retirer',
            mustSwitchFirst: 'Tu dois passer à une autre langue avant de retirer celle-ci.',
            editProfile: 'Modifier le profil',
            learning: 'J’apprends',
            currentLevel: 'Niveau actuel',
            change: 'Modifier',
            appLanguage: 'Langue de l’appli',
            chooseAppLanguage: 'Choisis la langue de l’interface de l’appli.',
            addAnotherLanguage: 'Ajouter une autre langue',
            switchLanguage: 'Changer de langue d’apprentissage',
            switchLanguageDesc: 'Cela remplace la langue que tu apprends actuellement. L’apprentissage de plusieurs langues à la fois arrive bientôt.',
            stats: 'Statistiques',
            totalXp: 'XP total',
            dayStreak: 'Jours d’affilée',
            wordsSaved: 'Mots enregistrés',
            lessonsDone: 'Leçons terminées',
            settings: 'Paramètres',
            notifications: 'Notifications',
            support: 'Assistance et retours',
            logOut: 'Se déconnecter',
            deleteAccount: 'Supprimer le compte',
            confirmLogOut: 'Veux-tu vraiment te déconnecter ?',
            cancel: 'Annuler',
            progressTab: 'Progrès',
            languagesTab: 'Langues',
            settingsTab: 'Paramètres',
            subscriptionTab: 'Abonnement',
            hrsStudied: 'h d’étude',
            lessonsCompleted: 'leçons terminées',
            levelManagement: 'Gestion du niveau',
            retakeTest: 'Refaire le test de niveau',
            retakeTestDesc: 'Obtiens une nouvelle évaluation de ton niveau',
            changeLevelManually: 'Changer de niveau manuellement',
            currently: 'Actuellement',
        },
        topicDetail: {
            lessonsComplete: 'Leçons terminées : {done} / {total}',
            upNext: 'À suivre',
            start: 'Commencer',
            lessonsTab: 'Leçons',
            deeperTab: 'Aller plus loin',
            aboutTab: 'À propos',
            results: 'Résultats',
            redo: 'Refaire',
            completeFirst: 'Termine d’abord une leçon',
            completeFirstDesc: 'Termine au moins une leçon de ce sujet pour débloquer des exercices supplémentaires.',
            deeperIntro: 'Exercices supplémentaires générés par IA pour ce sujet : du contenu neuf toutes les 24 heures.',
            coreVocab: 'Vocabulaire essentiel',
            coreVocabDesc: 'Passe en revue à toute vitesse les mots essentiels de ce sujet',
            grammarFocus: 'Focus grammaire',
            grammarFocusDesc: 'Les structures grammaticales clés de ce sujet',
            convPractice: 'Pratique de la conversation',
            convPracticeDesc: 'Rassemble tout dans de vraies phrases en {lang}',
            gabiConv: 'Conversation avec Gabi',
            gabiConvDesc: 'Entraîne-toi à parler avec Gabi sur ce sujet',
            min: 'min',
            whatYoullLearn: 'Ce que tu vas apprendre',
            levelLabel: 'Niveau',
            lessonsLabel: 'Leçons',
            lessonsInfo: '{n} leçons · environ {m} minutes',
            includes: 'Comprend',
            includesText: 'Vocabulaire, grammaire, prononciation, une séance de conversation avec Gabi et un test sur le sujet.',
        },
    },
    pt: {
        topics: {
            title: 'Tópicos',
            searchPlaceholder: 'Buscar tópicos...',
            allLevels: 'Todos os níveis',
            noTopicsFound: 'Nenhum tópico encontrado',
            tryDifferentSearch: 'Tente outro termo de busca',
            locked: 'Bloqueado',
            levelNames: {
                A1: 'Iniciante',
                A2: 'Elementar',
                B1: 'Intermediário',
                B2: 'Intermediário superior',
                C1: 'Avançado',
                C2: 'Domínio',
            },
        },
        grammar: {
            title: 'Gramática',
            searchPlaceholder: 'Busque qualquer verbo...',
            lookUp: 'Buscar',
            intro: 'Toque em qualquer verbo para ver a conjugação completa em todos os tempos e salvar formas no seu Word Bank. Não encontrou o verbo que procura? Busque',
            introBold: 'qualquer',
            introEnd: 'verbo na barra acima, não só os da lista abaixo.',
            verbs: 'verbos',
        },
        profile: {
            title: 'Perfil',
            myProfile: 'Meu perfil',
            freePlan: 'Plano gratuito',
            active: 'Ativo',
            tapToSwitch: 'Toque para trocar',
            learnMultiple: 'Aprenda vários idiomas e alterne entre eles quando quiser',
            account: 'Conta',
            displayName: 'Nome de exibição',
            emailAddress: 'Endereço de e-mail',
            changePassword: 'Alterar senha',
            updatePassword: 'Atualize sua senha',
            prefs: 'Preferências',
            notificationsDesc: 'Lembretes diários e alertas de sequência',
            soundEffects: 'Efeitos sonoros',
            on: 'Ativados',
            helpSupport: 'Ajuda e suporte',
            helpSupportDesc: 'Perguntas frequentes e fale conosco',
            termsPrivacy: 'Termos e política de privacidade',
            termsPrivacyDesc: 'Leia nossos termos de serviço',
            dangerZone: 'Zona de perigo',
            deleteMyAccount: 'Excluir minha conta',
            deleteMyAccountDesc: 'Exclua permanentemente sua conta e todos os seus dados',
            deleteAccountTitle: 'Excluir sua conta?',
            deleteAccountWarning: 'Isso vai excluir permanentemente sua conta, todo o seu progresso, seu Word Bank e o histórico de conversas. Essa ação não pode ser desfeita.',
            enterPasswordConfirm: 'Digite sua senha para confirmar:',
            yourPassword: 'Sua senha',
            deleting: 'Excluindo...',
            deleteAccountBtn: 'Excluir conta',
            currentPlanFree: 'Você tem acesso aos 3 primeiros tópicos de cada nível e a 2 sessões com a Gabi por dia.',
            unlockEverything: 'Desbloqueie tudo',
            unlockDesc: 'Tenha acesso completo a todos os tópicos, conversas ilimitadas com a Gabi, preparação para exames e muito mais.',
            featureAllTopics: 'Todos os tópicos em todos os níveis',
            featureUnlimitedLuna: 'Conversas ilimitadas com a Gabi',
            featureExamPrep: 'Preparação completa para exames',
            featureUnlimitedWordBank: 'Word Bank ilimitado',
            featureFullStats: 'Estatísticas completas e acompanhamento Cambridge',
            seePlans: 'Ver planos',
            removeLanguageTitle: 'Remover este idioma?',
            removeLanguageDesc: 'Isso vai excluir permanentemente todo o seu progresso, seu Word Bank e seu histórico deste idioma. Essa ação não pode ser desfeita.',
            remove: 'Remover',
            mustSwitchFirst: 'Você precisa trocar para outro idioma antes de remover este.',
            editProfile: 'Editar perfil',
            learning: 'Aprendendo',
            currentLevel: 'Nível atual',
            change: 'Alterar',
            appLanguage: 'Idioma do app',
            chooseAppLanguage: 'Escolha o idioma da interface do app.',
            addAnotherLanguage: 'Adicionar outro idioma',
            switchLanguage: 'Trocar idioma de aprendizado',
            switchLanguageDesc: 'Isso substitui o idioma que você está aprendendo agora. O suporte para aprender vários idiomas ao mesmo tempo chega em breve.',
            stats: 'Estatísticas',
            totalXp: 'XP total',
            dayStreak: 'Dias seguidos',
            wordsSaved: 'Palavras salvas',
            lessonsDone: 'Lições concluídas',
            settings: 'Configurações',
            notifications: 'Notificações',
            support: 'Suporte e feedback',
            logOut: 'Sair',
            deleteAccount: 'Excluir conta',
            confirmLogOut: 'Tem certeza de que quer sair?',
            cancel: 'Cancelar',
            progressTab: 'Progresso',
            languagesTab: 'Idiomas',
            settingsTab: 'Configurações',
            subscriptionTab: 'Assinatura',
            hrsStudied: 'h de estudo',
            lessonsCompleted: 'lições concluídas',
            levelManagement: 'Gerenciar nível',
            retakeTest: 'Refazer o teste de nível',
            retakeTestDesc: 'Receba uma nova avaliação do seu nível',
            changeLevelManually: 'Alterar o nível manualmente',
            currently: 'Atualmente',
        },
        topicDetail: {
            lessonsComplete: '{done} de {total} lições concluídas',
            upNext: 'A seguir',
            start: 'Começar',
            lessonsTab: 'Lições',
            deeperTab: 'Aprofundar',
            aboutTab: 'Sobre',
            results: 'Resultados',
            redo: 'Refazer',
            completeFirst: 'Conclua uma lição primeiro',
            completeFirstDesc: 'Termine pelo menos uma lição deste tópico para liberar prática extra.',
            deeperIntro: 'Prática extra gerada por IA para este tópico: conteúdo novo a cada 24 horas.',
            coreVocab: 'Vocabulário essencial',
            coreVocabDesc: 'Revise rapidamente as palavras essenciais deste tópico',
            grammarFocus: 'Foco em gramática',
            grammarFocusDesc: 'As principais estruturas gramaticais deste tópico',
            convPractice: 'Prática de conversação',
            convPracticeDesc: 'Junte tudo em frases reais em {lang}',
            gabiConv: 'Conversa com a Gabi',
            gabiConvDesc: 'Pratique falar com a Gabi sobre este tópico',
            min: 'min',
            whatYoullLearn: 'O que você vai aprender',
            levelLabel: 'Nível',
            lessonsLabel: 'Lições',
            lessonsInfo: '{n} lições · cerca de {m} minutos',
            includes: 'Inclui',
            includesText: 'Vocabulário, gramática, pronúncia, uma sessão de conversa com a Gabi e um teste do tópico.',
        },
    },
};